import type { Me } from '../api/client';

/** Sin 2FA y con el 2FA obligatorio (RF-AUTH-04, RNF-PLAT-01): solo puede ir a activarlo. */
export const mustEnrollTotp = (me: Me): boolean => me.totpRequired === true && me.totpEnabled !== true;

/**
 * Adónde va cada uno al entrar (P1 de la consola de plataforma):
 * - con el 2FA pendiente, a activarlo;
 * - con clínica activa, a Mi día;
 * - el administrador de plataforma sin membresías, a la consola;
 * - el resto, al selector (que para la plataforma suma "Plataforma" arriba de todo).
 */
export function homeFor(me: Me): string {
  if (mustEnrollTotp(me)) return '/two-factor';
  if (me.activeClinicId != null) return '/my-day';
  if (me.isPlatformAdmin === true && (me.memberships ?? []).length === 0) return '/platform';
  return '/select-clinic';
}
